<template>
  <v-form>
    <v-row dense>
      <v-col cols="3">
        <span style="font-size: 18px; font-weight: bold; color: red">{{ record.Name }}</span>
      </v-col>

      <v-col cols="3">
        <v-file-input
          nmae="priceListFile"
          v-model="excelFile"
          label="Browse Excel Sheet"
          outlined
          dense
        ></v-file-input>
      </v-col>

      <v-col cols="2">
        <v-btn color="accent" :loading="loader" @click="sendData">Update</v-btn>
      </v-col>

      <v-col cols="12">
        <v-text-field
          name="managePriceListSearch"
          dense
          outlined
          label="Search"
          v-model="search"
        ></v-text-field>
      </v-col>

      <v-col cols="6">
        <!-- excel icon -->
        <download-excel :data="itm4" :fields="fields" name="Selling Prices">
          <v-btn icon>
            <v-icon color="green" class="pointer">mdi-file-excel</v-icon>
          </v-btn>
        </download-excel>
        <!-- end -->
      </v-col>

      <v-col cols="6">
        <v-btn text color="accent" @click="getProductPriceReport">
          Print Labels
        </v-btn>
      </v-col>

      <v-col cols="12">
        <v-data-table
          :mobile-breakpoint="zeroValue"
          :items-per-page="pageItems"
          :headers="headers"
          :items="itm4"
          :search="search"
        >
          <!-- action template -->
          <template v-slot:item.action="{ item }">
            <v-btn color="editIcon" icon @click="openModal(item)">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </template>
          <!-- end -->
        </v-data-table>
      </v-col>
    </v-row>

    <!-- Edit dialog -->
    <v-dialog v-model="dialog" max-width="850px">
      <v-card>
        <v-toolbar dense color="primary" dark>
          <v-toolbar-title>Edit Selling Price</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container fluid>
            <v-row>
              <v-col cols="12" xs="12" md="6" v-if="editItem.product">
                <span class="style-18">{{ editItem.product.Name }}</span>
              </v-col>

              </v-row>

              <v-row>

                <v-col cols="12" xs="12" md="4">
                <v-text-field
                  name="priceListBuyingPrice"
                  v-model="editItem.BuyingPrice"
                  label="Buying Price"
                  outlined
                  dense
                ></v-text-field>
              </v-col>


              <v-col cols="12" xs="12" md="4">
                <v-text-field
                  name="priceListSellingPrice"
                  v-model="editItem.SellingPrice"
                  label="Selling Price"
                  outlined
                  dense
                ></v-text-field>
              </v-col>

              <v-col cols="12" xs="12" md="4">
                <v-text-field
                  name="priceListSellingLowerLimit"
                  v-model="editItem.LeastPrice"
                  label="Lower Limit"
                  outlined
                  dense
                ></v-text-field>
              </v-col>

              <v-col cols="6">
                <v-btn
                  color="accent"
                  @click="save"
                  :loading="$store.state.btnLoader"
                >
                  <v-icon left>mdi-content-save</v-icon> Update
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- end of edit dialog -->
  </v-form>
</template>


<script>
import jsPDF from "jspdf";
import "jspdf-autotable";
export default {
  name: "PriceListIndex",
  props: {
    initial: {
      type: Object,
      required: true,
    },
    docCreate: {
      type: Boolean,
    },
    priceList: {
      type: String,
    },
  },
  data: () => ({
    search: "",
    zeroValue: 0,
    pageItems: 100,
    excelFile: null,
    dialog: false,
    editItem: {},
    loader: false,
    record: {},
    itm4: [],
    productPriceReport: [],
    headers: [
      { text: "Product", value: "product.Name" },
      { text: "Selling Price", value: "BuyingPrice" },
      { text: "Selling Price", value: "SellingPrice" },
      { text: "Least Price", value: "LeastPrice" },
      { text: "Action", value: "action" },
    ],
    fields: {
      Product: "Name",
      SellingPrice: "SellingPrice",
    },
    date: new Date().toISOString().substr(0, 10),
  }),
  watch: {
    initial: {
      handler: "init",
      immediate: true,
    },
  },
  methods: {
    init(val) {
      this.itm4 = val.itm4;
      this.record = { ...val };
    },
    setDate(date) {
      this.record.date = date;
    },
    openModal(data) {
      this.editItem = data;
      this.dialog = true;
    },
    sendData() {
      const data = new FormData();
      console.log(this.record, ' id');
      data.append("productsData", this.excelFile);
      data.append("o_p_l_n_s_id", this.record.id);
      this.$store.commit("btnLoader", true);

      this.$emit("data", data);
    },
    save() {
     const id = this.editItem.id;
    const url = `/price-list-row/${id}`;
      const data = {
        id: parseInt(this.editItem.id),
        BuyingPrice: parseFloat(this.editItem.BuyingPrice),
        SellingPrice: parseFloat(this.editItem.SellingPrice),
        LeastPrice: parseFloat(this.editItem.LeastPrice),
      };

      const self = this;
      this.$store.commit("btnLoader", true);
      this.$store
        .dispatch("put", { url, data })
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.$store.commit("btnLoader", false);
            location.reload();
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getProductPriceReport() {
      this.$store.commit("btnLoader", false);
      const self = this;
      this.loader = true;
      this.$store
        .dispatch("get", `/products-price-report/${this.record.id}`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.productPriceReport = res.ResponseData;
            self.loader = false;
            this.printList();
          } else {
            self.loader = false;
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          self.loader = false;
          this.$refs.snackbar.show(err, "red");
        });
    },

    printList() {
      var doc = new jsPDF({ compress: true });

      var pageWidth =
        doc.internal.pageSize.width || doc.internal.pageSize.getWidth();
      const itemDetails = [];
      for (const note of this.productPriceReport) {
        const itemDetail = {
          col1: note[0] ? note[0].ItemName : null,
          col2: note[1] ? note[1].ItemName : null,
          col3: note[2] ? note[2].ItemName : null,
        };
        itemDetails.push(itemDetail);
      }

      doc.autoTable({
        head: this.headRowsItemDetails,
        body: itemDetails,
        theme: "grid",

        margin: { left: 2, right: 2 },
        tableWidth: pageWidth - 5,
        columnStyles: {
          col1: {
            halign: "center",
          },
          col2: {
            halign: "center",
          },
          col3: {
            halign: "center",
          },
        },
        bodyStyles: {
          fontSytel: "bold",
          textColor: "#000000",
        },
        styles: { cellPadding: 9, fontSize: 11 },
        allSectionHooks: true,

        startY: 5,
      });
      window.open(doc.output("bloburl"), "_blank");
    },
  },
};
</script>